'use client';

import { Tag } from '@coolblue-development/freddy';
import selectOptionTrigger from '@coolblue-development/ga4-events/triggers/InternalIcons/selectOptionTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { ReactElement } from 'react';

import { openInternalPopup } from '../../utils/internalPopup';

export default function OnlineStockIconTag({
  url,
  index,
  totalIndices,

  message
}: {
  url: string;
  index: number;
  totalIndices: number;
  message: string;
}): ReactElement {
  const { trackEvent } = useAnalytics();

  return (
    <Tag
      onClick={() => {
        trackEvent(
          selectOptionTrigger({
            sub_feature: 'stock_information',
            index: index,
            total_indices: totalIndices,
            selection_type: 'selected',
            option_name: 'online_stock',
            attribute: 'online_stock'
          })
        );
        openInternalPopup(url);
      }}
      variant='subtle'
      intent='neutral'
    >
      {message}
    </Tag>
  );
}
